<template>
  <div class="recruitments-card">
    <div class="recruitments-card__header">
      <div class="recruitments-card__title-container">
        <h2 class="recruitments-card__title">Recruitments</h2>
        <p class="recruitments-card__subtitle">{{ countMembers }} CANDIDATES</p>
      </div>
      <v-btn dark color="blue" class="fw-400" @click="addRecruitment">
        ADD NEW
      </v-btn>
    </div>

    <div class="recruitments-card__table">
      <v-data-table
        :headers="recruitmentsTable"
        :items="recruitmentsWithIndex"
        :items-per-page="100"
        hide-default-footer
        :show-arrows="true"
        dense
        no-data-text="No data"
        no-results-text="No data for that filters"
        class="dense-table"
      >
        <template #item.position="{ item }">
          <span class="recruitments-card__index">#{{ item.index }}</span>
          <router-link
            :to="{
              name: 'recruitment-show',
              params: { projectId: $route.params.id, recruitmentId: item.id }
            }"
            class="recruitments-card__position"
          >
            {{ item.position }}
          </router-link>
        </template>

        <template #item.time="{ item }">
          {{ item.start_date | displayDate }} - {{ item.end_date | displayDate }}
        </template>

        <template #item.experience_in_years="{ value }">
          {{ value }}+ years
        </template>

        <template #item.rate="{ value }">
          {{ value }} / h
        </template>

        <template #item.candidates_count="{ value }">
          <div class="recruitments-card__applications-info">
            {{ value }} candidates
          </div>
        </template>

        <template #item.action="{ item }">
          <v-menu left min-width="100">
            <template v-slot:activator="{ on }">
              <v-btn icon color="secondary" v-on="on">
                <v-icon large>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>

            <v-list dense elevation-2>
              <v-list-item link
                :to="{
                  name: 'recruitment-show',
                  params: { projectId: $route.params.id, recruitmentId: item.id }
                }"
              >
                <v-list-item-title>View details</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { recruitmentsTable } from '@/helpers/tableHeaders';

export default {
  props: {
    recruitments: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      recruitmentsTable,
    };
  },

  computed: {
    countMembers() {
      return this.recruitments.reduce((prev, curr) => prev + curr.candidates_count, 0);
    },

    recruitmentsWithIndex() {
      return this.recruitments.map(
        (recruitments, index) => ({
          ...recruitments,
          index: index + 1,
        }),
      );
    },
  },

  methods: {
    addRecruitment() {
      this.$router.push({ name: 'recruitment-create', params: { projectId: this.$route.params.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.recruitments-card {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__title {
    font-size: 18px;
    font-weight: 500;
    line-height: 21px;
    color: $main--headers;
  }

  &__subtitle {
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    color: $color--blue;
  }

  &__index {
    font-weight: bold;
    color: $main--text;
    margin-right: 16px;
  }

  &__position {
    font-weight: bold;
    text-decoration: unset;
  }

  &__applications-info {
    font-size: 10px;
    background: $color--blue-light;
    border-radius: 16px;
    color: $color--blue;
    padding: 4px 16px;
    text-align: center;
  }
}
</style>
